import type { ExperimentSection } from 'definitions';
import type { Experiment } from 'types';
import { UserAvatar } from '@/components/UserAvatar';
import { sectionAuthor } from '@/state/experiments/section-authors';

type SectionAuthorProps = {
  experiment: Pick<Experiment, 'sectionAuthors'>;
  section: ExperimentSection;
  /** Whether the section currently has anything in it. An empty section shows no author. */
  hasContent: boolean;
};

/**
 * Who first wrote a section of the brief, or the debrief: the badge alone, with the full
 * name on hover, as in the library's "Created by" column. Nothing is rendered when the
 * section is empty or nobody is on record, which is every section written before authors
 * were recorded.
 */
export const SectionAuthor = ({ experiment, section, hasContent }: SectionAuthorProps) => {
  const user = sectionAuthor({ experiment, section });
  if (!hasContent || !user) return null;

  return <UserAvatar user={user} size="sm" tooltip />;
};
